<style lang="stylus">
    .ft-submenu
        position relative

        .ft-submenu-expand
            position absolute
            top 0
            left calc(100% + 6px)
            width max-content
            background $ft-bgcolor
            box-shadow $ft-boxshadow
            border-radius 6px
            z-index 1
</style>

<template>
    <div ref="submenuParent" class="ft-submenu" :class="{ disable: disable }">
        <FtMenu
            :imgIcon="imgIcon"
            :text="text"
            :isExpand="isExpand"
            :active="showExpand"
            :underColor="underColor"
            @mouseenter.native="mouseEnterMenu()"
            @mouseleave.native="mouseLeaveMenu()"
        />
        <div
            ref="submenuChild"
            class="ft-submenu-expand"
            v-show="showExpand"
            @mouseenter="mouseEnterContent()"
            @mouseleave="mouseLeaveContent()"
            @click="clickContent"
        >
            <template v-if="lockbox">
                <LockBoxForTitle
                    v-transfer-dom
                    ref="lockboxDom"
                    style="z-index: 20"
                    v-show="showLockBox"
                    :data-transfer="true"
                    :name="lockboxTitle"
                    :dragTitle="lockboxTitle"
                    :show="showLockBox"
                    @lockModal="lockBox = true"
                    @clickModal="showBox = false"
                    @closeModal="closeLockBox()"
                    @mouseenter.native="mouseEnterContent()"
                    @mouseleave.native="mouseLeaveContent()"
                >
                    <slot name="lockboxContent" />
                </LockBoxForTitle>
            </template>
            <template v-else>
                <slot name="content" />
            </template>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import FtMenu from "./FtMenu.vue";
    import LockBoxForTitle from "../LockBoxForTitle.vue";
    import { floatPopPositonFit } from "../positionfit";

    @Component({
        components: {
            FtMenu,
            LockBoxForTitle,
        },
    })
    export default class FTSubMenu extends Vue {
        @Prop() imgIcon;
        @Prop() text;
        @Prop() isExpand;
        @Prop() lock;
        @Prop() disable;
        @Prop({ default: false }) readonly lockbox: boolean; // 可固定面板
        @Prop({ default: "" }) readonly lockboxTitle: string; // 面板标题
        @Prop({ default: "" }) readonly underColor: string; // 部分图标下方的预览颜色

        closeTimer = 0;
        openTimer = 0;
        showExpand = false;
        floatPopPositonFit = null;
        showBox = false;
        lockBox = false;

        get showLockBox() {
            return this.lockBox || this.showBox;
        }

        showChild() {
            this.showExpand = true;
            this.showBox = true;
            this.initPosition();
        }

        closeChild() {
            if (this.lock) return;
            this.showExpand = false;
            this.showBox = false;
        }

        cleanClose() {
            clearTimeout(this.closeTimer);
        }

        cleanOpen() {
            clearTimeout(this.openTimer);
        }

        mouseEnterMenu() {
            this.openTimer = setTimeout(() => {
                this.showChild();
            }, 300);
        }

        closeLockBox() {
            this.showBox = false;
            this.lockBox = false;
        }

        mouseLeaveMenu() {
            this.cleanOpen();
            this.closeTimer = setTimeout(() => {
                this.closeChild();
            }, 300);
        }

        mouseEnterContent() {
            this.cleanClose();
        }

        mouseLeaveContent() {
            this.closeChild();
        }

        clickContent() {
            this.closeChild();
            console.log(">>>>>>>>>>>>>>>> <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
        }

        // 适应位置
        getParentData() {
            const boxPadding = 6;
            const parentdom = this.$refs.submenuParent as HTMLElement;
            const rect: DOMRect = parentdom.getBoundingClientRect() as DOMRect;
            return {
                x: rect.x - boxPadding,
                y: rect.y - boxPadding,
                w: rect.width + 2 * boxPadding,
                h: rect.height + 2 * boxPadding,
            };
        }
        getChildData() {
            const childDom = this.$refs.submenuChild as HTMLElement;
            let rect: DOMRect = childDom.getBoundingClientRect() as DOMRect;
            if (this.lockbox) {
                const childDom = (this.$refs.lockboxDom as any).$el as HTMLElement;
                let rect2 = childDom.getBoundingClientRect() as DOMRect;
                rect.width = rect2.width;
                rect.height = rect2.height;
            }
            return {
                x: rect.x,
                y: rect.y,
                w: rect.width,
                h: rect.height,
            };
        }
        initPosition() {
            this.$nextTick(() => {
                this.resetPosition();
                if (this.lockbox) {
                    if (this.lockBox) return;
                    const cData = this.getChildData(),
                        pData = this.getParentData();
                    let position = this.floatPopPositonFit.checkLv2Position(pData, cData);
                    let dom = this.$refs.lockboxDom as any;
                    dom.initPosition({ x: position[0], y: position[1] });
                } else {
                    const cData = this.getChildData(),
                        pData = this.getParentData();
                    let position = this.floatPopPositonFit.checkLv2Position(pData, cData);
                    let dom = this.$refs.submenuChild as HTMLElement;
                    let rootDom = this.$refs.submenuParent as HTMLElement;
                    const rect: DOMRect = rootDom.getBoundingClientRect() as DOMRect;
                    console.log(position, this.getChildData());
                    dom.style.left = `${position[0] - rect.x + 4}px`;
                    dom.style.top = `${position[1] - rect.y}px`;
                }
            });
        }
        // 初始化可固定面板位置
        initLockboxPosition() {
            if (this.lockBox) return;
            this.resetPosition();
            let lockDom = this.$refs.lockboxDom;

            let dom = this.$refs.submenuParent as HTMLElement,
                rect = dom.getBoundingClientRect() as DOMRect;
            let width = dom.offsetWidth,
                height = dom.offsetHeight,
                left = rect.x,
                top = rect.y,
                gap = 6;
            let lockboxDom = (this.$refs.lockboxDom as any).$el as HTMLElement,
                lockboxHeight = lockboxDom.offsetHeight;
            if (top + lockboxHeight > window.innerHeight) {
                top = window.innerHeight - lockboxHeight;
            }
            (this.$refs.lockboxDom as any).initPosition({ x: left + width + gap, y: top });
        }
        resetPosition() {
            if (this.lockbox) {
                if (this.lockBox) return;
                let dom = this.$refs.submenuParent as HTMLElement,
                    rect = dom.getBoundingClientRect() as DOMRect;
                let width = dom.offsetWidth,
                    height = dom.offsetHeight,
                    left = rect.x,
                    top = rect.y,
                    gap = 6;
                (this.$refs.lockboxDom as any).initPosition({ x: left + width + gap, y: top });
            } else {
                let dom = this.$refs.submenuChild as HTMLElement;
                dom.style.left = `calc(100% + 6px)`;
                dom.style.top = `0`;
            }
        }

        created() {}
        mounted() {
            this.floatPopPositonFit = floatPopPositonFit;
        }
    }
</script>
